import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface meState {
  isAuthenticated: boolean;
  firstName: string;
  role: string;
}
/// ข้อ 1 สร้างค่าเริ่มต้น
//accessToken
const user = JSON.parse(localStorage.getItem("user") ?? "false");
// console.log(user);

const initialState = {
  isAuthenticated: user.accessToken ? true : false,
  firstName: user.firstName ? user.firstName : "",
  role: user.role ? user.role.name : "",
} as meState;
/// ข้อ 2 สร้าง func สำหรับแก้ไขข้อมูล
const meSlice = createSlice({
  // **กำหนดชื่อ
  name: "me",

  // **เอาค่าเริ่มต้นมาใส่
  initialState,

  // **สร้าง reducers:{ ข้างในจะเป็น func สำหรับแก้ไขข้อมูล}
  reducers: {
    setIsAuthenticated(state, action: PayloadAction<meState>) {
      // console.log(state);

      state.isAuthenticated = action.payload.isAuthenticated;
      state.firstName = action.payload.firstName;
      state.role = action.payload.role;
    },
  },
});

//export ให้ที่อื่นนำไปใช้ func
export const { setIsAuthenticated } = meSlice.actions;
// export default store;
export default meSlice.reducer;
